import { styled } from "../stitches.config";

export const Sub = styled("sub", {
  fontFeatureSettings: '"subs"',
  fontSize: "100%",
  lineHeight: "1",
  verticalAlign: "baseline",
});
